export enum MenuState {
  Hidden = 1,
  Collapsed = 2,
  Expanded = 3,
}
